import { Configuration, SuppliersApi } from '@/api';
import ApiConfig from '@/api/ApiConfig';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const useGetSupplierQuery = (supplierId?: string, apiConfig?: Partial<ApiConfig>) => {
  const queryClient = useQueryClient();

  const suppliersApi = new SuppliersApi(new Configuration(apiConfig || useAuth));

  const {
    isLoading,
    data: supplier,
    error,
  } = useQuery({
    queryKey: ['supplier', supplierId],
    queryFn: () => {
      return supplierId ? suppliersApi.getSupplier(supplierId) : null;
    },
    enabled: !!supplierId,
  });

  const invalidateQuery = async (alsoInvalidateList = false) => {
    await queryClient.invalidateQueries({ queryKey: ['supplier', supplierId] });

    if (alsoInvalidateList) {
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'suppliers',
      });
    }
  };

  return {
    supplier,
    isLoading,
    error,
    invalidateQuery,
  };
};

export default useGetSupplierQuery;
